(() => {
  const replacements = new Map([
    ['Customer reviews', 'Müşteri yorumları'],
    ['Write a review', 'Yorum yaz'],
    ['Reviews', 'Yorumlar'],
    ['No reviews yet', 'Henüz yorum yok'],
    ['Search reviews', 'Yorumlarda ara'],
    ['Most relevant', 'En ilgili'],
    ['All ratings', 'Tüm puanlar'],
    ['With media', 'Fotoğraflı'],
    ['Clear all filters', 'Tüm filtreleri temizle'],
    ['No matching reviews', 'Eşleşen yorum yok'],
    ['Try another search, or clear some filters', 'Başka bir arama deneyin veya filtreleri temizleyin'],
    ['TRY ANOTHER SEARCH, OR CLEAR SOME FILTERS', 'BAŞKA BİR ARAMA DENEYİN VEYA FİLTRELERİ TEMİZLEYİN'],
    ['Clear all', 'Temizle'],
    ['CLEAR ALL', 'TEMİZLE'],
    ['Submit', 'Gönder'],
    ['Cancel', 'Vazgeç'],
    ['review', 'yorum'],
    ['reviews', 'yorum']
  ]);

  const roots = ['#klaviyo-product-reviews-wrapper', '#klaviyo-reviews-all', '.klaviyo-reviews-widget', '[class*="klaviyo-reviews"]', '[class*="kl_reviews"]'];

  const displayLabels = new Set(['müşteri yorumları', 'yorumlar', 'henüz yorum yok', 'eşleşen yorum yok']);
  const filterLabels = new Set(['fotoğraflı', 'tüm puanlar', 'en ilgili', 'tüm filtreleri temizle']);

  const applyDisplayTextStyle = (element) => {
    element.style.setProperty('color', '#d00000', 'important');
    element.style.setProperty('font-family', 'var(--main-font-stack, Arial, Helvetica, sans-serif)', 'important');
    element.style.setProperty('font-weight', '800', 'important');
    element.style.setProperty('letter-spacing', '0', 'important');
    element.style.setProperty('text-transform', 'uppercase', 'important');
  };

  const applyFilterTextStyle = (element) => {
    element.style.setProperty('color', '#d00000', 'important');
    element.style.setProperty('font-family', 'var(--main-font-stack, Arial, Helvetica, sans-serif)', 'important');
    element.style.setProperty('font-size', '14px', 'important');
    element.style.setProperty('font-weight', '600', 'important');
    element.style.setProperty('letter-spacing', '0', 'important');
    element.style.setProperty('text-transform', 'none', 'important');
  };

  const applyReviewButtonStyle = (button) => {
    button.style.setProperty('width', '140px', 'important');
    button.style.setProperty('min-width', '140px', 'important');
    button.style.setProperty('max-width', '140px', 'important');
    button.style.setProperty('height', '50px', 'important');
    button.style.setProperty('min-height', '50px', 'important');
    button.style.setProperty('padding', '0 18px', 'important');
    button.style.setProperty('border', '2px solid #d00000', 'important');
    button.style.setProperty('border-radius', '9px', 'important');
    button.style.setProperty('background', '#ffffff', 'important');
    button.style.setProperty('box-shadow', 'none', 'important');
    button.style.setProperty('color', '#d00000', 'important');
    button.style.setProperty('font-family', 'var(--main-font-stack, Arial, Helvetica, sans-serif)', 'important');
    button.style.setProperty('font-size', '14px', 'important');
    button.style.setProperty('font-weight', '800', 'important');
    button.style.setProperty('line-height', '46px', 'important');
    button.style.setProperty('letter-spacing', '0', 'important');
    button.style.setProperty('text-align', 'center', 'important');
    button.style.setProperty('text-transform', 'uppercase', 'important');

    let holder = button.parentElement;
    for (let index = 0; holder && index < 4; index += 1) {
      const rect = holder.getBoundingClientRect();
      if (rect.width > 220 && rect.height < 140) {
        holder.style.setProperty('display', 'flex', 'important');
        holder.style.setProperty('justify-content', 'flex-end', 'important');
        holder.style.setProperty('align-items', 'center', 'important');
        holder.style.setProperty('text-align', 'right', 'important');
        break;
      }
      holder = holder.parentElement;
    }
  };

  const fixBlueAccent = (root) => {
    root.querySelectorAll('*').forEach((element) => {
      const style = window.getComputedStyle(element);
      const isBlueBackground = style.backgroundColor.startsWith('rgb(0,') || style.backgroundColor.startsWith('rgba(0,');
      const isBlueBorder = style.borderBottomColor.startsWith('rgb(0,') || style.borderBottomColor.startsWith('rgba(0,');
      const rect = element.getBoundingClientRect();
      if ((isBlueBackground || isBlueBorder) && rect.height <= 8 && rect.width >= 24) {
        element.style.setProperty('background-color', '#d00000', 'important');
        element.style.setProperty('border-color', '#d00000', 'important');
        element.style.setProperty('border-bottom-color', '#d00000', 'important');
        element.style.setProperty('box-shadow', 'inset 0 -4px 0 #d00000', 'important');
      }
    });
  };

  const styleRoot = (root) => {
    root.querySelectorAll('*').forEach((element) => {
      element.style.setProperty('font-family', 'var(--main-font-stack, Arial, Helvetica, sans-serif)', 'important');
      const label = element.textContent.trim().toLocaleLowerCase('tr-TR');
      if (displayLabels.has(label)) applyDisplayTextStyle(element);
      if (filterLabels.has(label)) applyFilterTextStyle(element);
    });
    root.querySelectorAll('.kl_reviews__button').forEach((button) => {
      applyReviewButtonStyle(button);
    });
    root.querySelectorAll('button, a[role="button"], input[type="button"], input[type="submit"]').forEach((button) => {
      const label = (button.value || button.textContent || '').trim().toLocaleLowerCase('tr-TR');
      if (label === 'yorum yaz' || label === 'write a review') applyReviewButtonStyle(button);
    });
    fixBlueAccent(root);
  };

  const translateText = (node) => {
    const value = node.nodeValue.trim();
    if (!value) return;
    if (replacements.has(value)) {
      node.nodeValue = node.nodeValue.replace(value, replacements.get(value));
      if (node.parentElement) applyDisplayTextStyle(node.parentElement);
      return;
    }
    const reviewMatch = value.match(/^([0-9]+) reviews$/i);
    if (reviewMatch) node.nodeValue = node.nodeValue.replace(value, `${reviewMatch[1]} yorum`);
  };

  const translateAttributes = (element) => {
    ['placeholder', 'aria-label', 'title'].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (!value) return;
      if (replacements.has(value)) element.setAttribute(attribute, replacements.get(value));
    });
  };

  const translateRoot = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const textNodes = [];
    while (walker.nextNode()) textNodes.push(walker.currentNode);
    textNodes.forEach(translateText);
    root.querySelectorAll('*').forEach(translateAttributes);
    styleRoot(root);
  };

  const translate = () => {
    roots.forEach((selector) => {
      document.querySelectorAll(selector).forEach(translateRoot);
    });
  };

  translate();
  new MutationObserver(translate).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
